import { GetOrderResponseType, TrackingItemType } from "api";

const jsonString =
  '{"errorMsg":null,"orderPos":[{"articleName":"JG LS1740SWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829341","itemID":1,"backorderPos":[{"articleName":"JG LS1740SWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829341","itemID":4,"backorderPos":null,"amountPending":0,"fixedItemID":4,"habblImageURL":"","amountInitial":200,"backorderItemID":1,"amountDelivered":196,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"amountPending":0,"fixedItemID":1,"habblImageURL":"","amountInitial":200,"backorderItemID":null,"amountDelivered":4,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null},{"articleName":"JG LS1740WWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829343","itemID":2,"backorderPos":[{"articleName":"JG LS1740WWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829343","itemID":3,"backorderPos":[{"articleName":"JG LS1740WWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829343","itemID":5,"backorderPos":[{"articleName":"JG LS1740WWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-01-15","trackingURL":"","orderNo":6468910,"articleNo":"6829343","itemID":6,"backorderPos":[{"articleName":"JG LS1740WWM Abdeckung mit Drehknopf","habblDeliveryDate":null,"dateExpected":"2026-02-02","trackingURL":"","orderNo":6468910,"articleNo":"6829343","itemID":7,"backorderPos":null,"amountPending":0,"fixedItemID":7,"habblImageURL":"","amountInitial":126,"backorderItemID":6,"amountDelivered":26,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"amountPending":0,"fixedItemID":6,"habblImageURL":"","amountInitial":126,"backorderItemID":5,"amountDelivered":100,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"amountPending":0,"fixedItemID":5,"habblImageURL":"","amountInitial":184,"backorderItemID":3,"amountDelivered":58,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"amountPending":0,"fixedItemID":3,"habblImageURL":"","amountInitial":194,"backorderItemID":2,"amountDelivered":10,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"amountPending":0,"fixedItemID":2,"habblImageURL":"","amountInitial":200,"backorderItemID":null,"amountDelivered":6,"requestedDeliveryDate":null,"habblGeoCoords":"","deliveryStatus":22,"salesUnit":"Stück","dateStorage":null}],"orderDate":"2026-01-07","orderID":44711201,"shippingMethodID":1,"shippingAddress":{"company1":"SIA \\"ATTA-1\\" Lampa LV","postalCode":"1007","city":"Riga","company2":"","company4":"","country":"Lettland","street":"Daugavgrivas street 77","company3":""}}';

const singleItemMockData: TrackingItemType = {
  articleNo: "single",
  deliveryStatus: 1,
  orderNo: 12345678,
  dateExpected: "2023-06-15",
  dateStorage: "2023-06-10",
  amountDelivered: 10,
  amountPending: 5,
  amountInitial: 15,
  salesUnit: "kg",
  articleName: "Product A (Status 1)",
  fixedItemID: 12345678,
  itemID: 12345678,
  amountOrdered: 15,
  deliveryNoteNumber: "lieferschein-123",
};

const mockOrderData: GetOrderResponseType = {
  shippingMethodID: 1,
  orderDate: "2023-06-01",
  dateExpected: "2023-06-01",
  orderID: "12345678",
  shippingAddress: {
    company1: "Musterfirma GmbH",
    country: "Deutschland",
    city: "Musterstadt",
    postalCode: "12345",
    street: "Musterstraße 1",
  },
  orderPos: [
    {
      ...singleItemMockData,
      habblGeoCoords:
        "https://www.google.com/maps/place/Alexander+B%C3%BCrkle-Ladestation/@48.0037532,7.8600518,17z/data=!3m1!4b1!4m6!3m5!1s0x47911c8ee8ef6265:0xd09570672ec81c99!8m2!3d48.0037496!4d7.8626267!16s%2Fg%2F11mk_sz5b3?entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D",
      habblImageURL:
        "https://as2.ftcdn.net/jpg/00/58/83/25/1000_F_58832597_bQiYyCxL8ull4CHinOi3NZ42LlguWQ2y.jpg",
      trackingURL: "https://www.dpd.com/de/de/",
      backorderPos: [
        { ...singleItemMockData },
        {
          ...singleItemMockData,
          backorderPos: [
            { ...singleItemMockData },
            { ...singleItemMockData },
            {
              ...singleItemMockData,
              backorderPos: [
                {
                  ...singleItemMockData,
                  backorderPos: [
                    {
                      ...singleItemMockData,
                      backorderPos: [{ ...singleItemMockData }],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      articleNo: "article-123",
      deliveryStatus: 1,
      orderNo: 123,
      dateExpected: "2023-06-15",
      dateStorage: "2023-06-10",
      amountDelivered: 10,
      amountPending: 5,
      salesUnit: "kg",
      articleName: "Product A (Status 1)",
      fixedItemID: 123,
      itemID: 123,
      amountInitial: 15,
      amountOrdered: 15,
      habblGeoCoords:
        "https://www.google.com/maps/place/Alexander+B%C3%BCrkle-Ladestation/@48.0037532,7.8600518,17z/data=!3m1!4b1!4m6!3m5!1s0x47911c8ee8ef6265:0xd09570672ec81c99!8m2!3d48.0037496!4d7.8626267!16s%2Fg%2F11mk_sz5b3?entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      articleNo: "article-124",
      deliveryStatus: 2,
      orderNo: 124,
      dateExpected: "2023-07-01",
      dateStorage: "2023-06-28",
      amountDelivered: 0,
      amountPending: 20,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "pcs",
      articleName: "Product B (Status 2)",
      fixedItemID: 124,
      itemID: 124,
    },
    {
      articleNo: "article-125",
      deliveryStatus: 3,
      orderNo: 125,
      dateExpected: "2023-06-20",
      dateStorage: "2023-06-18",
      amountDelivered: 5,
      amountPending: 0,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "l",
      articleName: "Product C (Status 3)",
      fixedItemID: 125,
      itemID: 125,
    },
    {
      articleNo: "article-126",
      deliveryStatus: 4,
      orderNo: 126,
      dateExpected: "2023-06-25",
      dateStorage: "2023-06-22",
      amountDelivered: 7,
      amountPending: 3,
      amountInitial: 10,
      amountOrdered: 10,
      salesUnit: "kg",
      articleName: "Product D (Status 4)",
      fixedItemID: 126,
      itemID: 126,
    },
    {
      articleNo: "article-127",
      deliveryStatus: 5,
      orderNo: 127,
      dateExpected: "2023-07-05",
      dateStorage: "2023-07-01",
      amountDelivered: 0,
      amountPending: 50,
      amountInitial: 50,
      amountOrdered: 50,
      salesUnit: "box",
      articleName: "Product E (Status 5)",
      fixedItemID: 127,
      itemID: 127,
    },
    {
      articleNo: "article-128",
      deliveryStatus: 6,
      orderNo: 128,
      dateExpected: "2023-06-30",
      dateStorage: "2023-06-29",
      amountDelivered: 12,
      amountPending: 0,
      amountInitial: 12,
      amountOrdered: 12,
      salesUnit: "pcs",
      articleName: "Product F (Status 6)",
      fixedItemID: 128,
      itemID: 128,
    },
    {
      articleNo: "article-129",
      deliveryStatus: 7,
      orderNo: 129,
      dateExpected: "2023-07-10",
      dateStorage: "2023-07-08",
      amountDelivered: 15,
      amountPending: 10,
      amountInitial: 25,
      amountOrdered: 25,
      salesUnit: "kg",
      articleName: "Product G (Status 7)",
      fixedItemID: 129,
      itemID: 129,
    },
    {
      articleNo: "article-130",
      deliveryStatus: 8,
      orderNo: 130,
      dateExpected: "2023-07-15",
      dateStorage: "2023-07-12",
      amountDelivered: 8,
      amountPending: 2,
      amountInitial: 10,
      amountOrdered: 10,
      salesUnit: "pcs",
      articleName: "Product H (Status 8)",
      fixedItemID: 130,
      itemID: 130,
    },
    {
      articleNo: "article-131",
      deliveryStatus: 9,
      orderNo: 131,
      dateExpected: "2023-07-20",
      dateStorage: "2023-07-18",
      amountDelivered: 20,
      amountPending: 0,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "l",
      articleName: "Product I (Status 9)",
      fixedItemID: 131,
      itemID: 131,
    },
    {
      articleNo: "article-132",
      deliveryStatus: 10,
      orderNo: 132,
      dateExpected: "2023-07-25",
      dateStorage: "2023-07-22",
      amountDelivered: 3,
      amountPending: 7,
      amountInitial: 10,
      amountOrdered: 10,
      salesUnit: "kg",
      articleName: "Product J (Status 10)",
      fixedItemID: 132,
      itemID: 132,
    },
    {
      articleNo: "article-133",
      deliveryStatus: 11,
      orderNo: 133,
      dateExpected: "2023-08-01",
      dateStorage: "2023-07-30",
      amountDelivered: 25,
      amountPending: 0,
      amountInitial: 25,
      amountOrdered: 25,
      salesUnit: "box",
      articleName: "Product K (Status 11)",
      fixedItemID: 133,
      itemID: 133,
    },
    {
      articleNo: "article-134",
      deliveryStatus: 12,
      orderNo: 134,
      dateExpected: "2023-08-05",
      dateStorage: "2023-08-03",
      amountDelivered: 18,
      amountPending: 0,
      amountInitial: 18,
      amountOrdered: 18,
      salesUnit: "pcs",
      articleName: "Product L (Status 12)",
      fixedItemID: 134,
      itemID: 134,
    },
    {
      articleNo: "article-135",
      deliveryStatus: 13,
      orderNo: 135,
      dateExpected: "2023-08-10",
      dateStorage: "2023-08-08",
      amountDelivered: 6,
      amountPending: 4,
      amountInitial: 10,
      amountOrdered: 10,
      salesUnit: "kg",
      articleName: "Product M (Status 13)",
      fixedItemID: 135,
      itemID: 135,
    },
    {
      articleNo: "article-136",
      deliveryStatus: 14,
      orderNo: 136,
      dateExpected: "2023-08-15",
      dateStorage: "2023-08-13",
      amountDelivered: 0,
      amountPending: 30,
      amountInitial: 30,
      amountOrdered: 30,
      salesUnit: "l",
      articleName: "Product N (Status 14)",
      fixedItemID: 136,
      itemID: 136,
    },
    {
      articleNo: "article-137",
      deliveryStatus: 15,
      orderNo: 137,
      dateExpected: "2023-08-20",
      dateStorage: "2023-08-18",
      amountDelivered: 9,
      amountPending: 11,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "pcs",
      articleName: "Product O (Status 15)",
      fixedItemID: 137,
      itemID: 137,
    },
    {
      articleNo: "article-138",
      deliveryStatus: 16,
      orderNo: 138,
      dateExpected: "2023-08-25",
      dateStorage: "2023-08-23",
      amountDelivered: 14,
      amountPending: 0,
      amountInitial: 14,
      amountOrdered: 14,
      salesUnit: "box",
      articleName: "Product P (Status 16)",
      fixedItemID: 138,
      itemID: 138,
    },
    {
      articleNo: "article-139",
      deliveryStatus: 17,
      orderNo: 139,
      dateExpected: "2023-09-01",
      dateStorage: "2023-08-30",
      amountDelivered: 22,
      amountPending: 0,
      amountInitial: 22,
      amountOrdered: 22,
      salesUnit: "kg",
      articleName: "Product Q (Status 17)",
      habblDeliveryDate: "2026-05-06T09:24:25",
      fixedItemID: 139,
      itemID: 139,
    },
    {
      articleNo: "article-140",
      deliveryStatus: 18,
      orderNo: 140,
      dateExpected: "2023-09-05",
      dateStorage: "2023-09-03",
      amountDelivered: 11,
      amountPending: 0,
      amountInitial: 11,
      amountOrdered: 11,
      salesUnit: "pcs",
      articleName: "Product R (Status 18)",
      fixedItemID: 140,
      itemID: 140,
    },
    {
      articleNo: "article-141",
      deliveryStatus: 19,
      orderNo: 141,
      dateExpected: "2023-09-10",
      dateStorage: "2023-09-08",
      amountDelivered: 16,
      amountPending: 0,
      amountInitial: 16,
      amountOrdered: 16,
      salesUnit: "l",
      articleName: "Product S (Status 19)",
      fixedItemID: 141,
      itemID: 141,
    },
    {
      articleNo: "article-142",
      deliveryStatus: 20,
      orderNo: 142,
      dateExpected: "2023-09-15",
      dateStorage: "2023-09-13",
      amountDelivered: 4,
      amountPending: 0,
      amountInitial: 4,
      amountOrdered: 4,
      salesUnit: "kg",
      articleName: "Product T (Status 20)",
      fixedItemID: 142,
      itemID: 142,
    },
    {
      articleNo: "article-143",
      deliveryStatus: 21,
      orderNo: 143,
      dateExpected: "2023-09-20",
      dateStorage: "2023-09-18",
      amountDelivered: 13,
      amountPending: 7,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "pcs",
      articleName: "Product U (Status 21)",
      fixedItemID: 143,
      itemID: 143,
    },
    {
      articleNo: "article-144",
      deliveryStatus: 22,
      orderNo: 144,
      dateExpected: "2023-09-25",
      dateStorage: "2023-09-23",
      amountDelivered: 0,
      amountPending: 25,
      amountInitial: 25,
      amountOrdered: 25,
      salesUnit: "box",
      articleName: "Product V (Status 22)",
      fixedItemID: 144,
      itemID: 144,
    },
    {
      articleNo: "article-145",
      deliveryStatus: 23,
      orderNo: 145,
      dateExpected: "2023-10-01",
      dateStorage: "2023-09-29",
      amountDelivered: 19,
      amountPending: 1,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "kg",
      articleName: "Product W (Status 23)",
      fixedItemID: 145,
      itemID: 145,
    },
    {
      articleNo: "article-146",
      deliveryStatus: 24,
      orderNo: 146,
      dateExpected: "2023-10-05",
      requestedDeliveryDate: "2023-10-10",
      dateStorage: "2023-10-03",
      amountDelivered: 0,
      amountPending: 1,
      amountInitial: 20,
      amountOrdered: 20,
      salesUnit: "kg",
      articleName: "Product X (Status 24)",
      fixedItemID: 146,
      itemID: 146,
    },
    {
      articleNo: "article-200",
      deliveryStatus: 8,
      orderNo: 200,
      dateExpected: "2026-06-01",
      requestedDeliveryDate: "2026-07-15",
      amountDelivered: 0,
      amountPending: 5,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "pcs",
      articleName:
        "Test A: Wunschdatum 15.07.2026 liegt nach vorrauss. Lieferdatum 01.06.2026 → Anzeige Wunschdatum 15.07.2026",
      fixedItemID: 200,
      itemID: 200,
    },
    {
      articleNo: "article-201",
      deliveryStatus: 4,
      orderNo: 201,
      dateExpected: "2026-08-01",
      requestedDeliveryDate: "2026-06-15",
      dateStorage: "2026-08-01",
      amountDelivered: 0,
      amountPending: 5,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "pcs",
      articleName:
        "Test B: Vorrauss. Lieferdatum 01.08.2026 liegt nach Wunschdatum 15.06.2026 (Verzug) → Anzeige vorrauss. Lieferdatum 01.08.2026",
      fixedItemID: 201,
      itemID: 201,
    },
    {
      articleNo: "article-202",
      deliveryStatus: 6,
      orderNo: 202,
      requestedDeliveryDate: "2026-09-01",
      amountDelivered: 0,
      amountPending: 5,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "pcs",
      articleName:
        "Test C: Nur Wunschdatum 01.09.2026 vorhanden, kein vorrauss. Lieferdatum → Anzeige Wunschdatum 01.09.2026",
      fixedItemID: 202,
      itemID: 202,
    },
    {
      articleNo: "article-203",
      deliveryStatus: 1,
      orderNo: 203,
      amountDelivered: 0,
      amountPending: 5,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "pcs",
      articleName:
        "Test D: Kein Wunschdatum, kein vorrauss. Lieferdatum → Anzeige leer",
      fixedItemID: 203,
      itemID: 203,
    },
    {
      articleNo: "article-204",
      deliveryStatus: 17,
      orderNo: 204,
      dateExpected: "2026-05-01",
      requestedDeliveryDate: "2026-06-01",
      habblDeliveryDate: "2026-04-30T14:15:00",
      amountDelivered: 5,
      amountPending: 0,
      amountInitial: 5,
      amountOrdered: 5,
      salesUnit: "pcs",
      articleName:
        "Test E: Wunschdatum 01.06.2026, vorrauss. Lieferdatum 01.05.2026 vorhanden, aber Endstatus (geliefert) → Anzeige leer",
      fixedItemID: 204,
      itemID: 204,
    },
  ],
};

export const getMockData = () => {
  const parsedMockData: GetOrderResponseType = JSON.parse(jsonString);
  return {
    orderPos: [
      ...(parsedMockData?.orderPos || []),
      ...(mockOrderData?.orderPos || []),
    ],
    shippingAddress: mockOrderData?.shippingAddress,
    orderDate: mockOrderData?.orderDate,
    dateExpected: mockOrderData?.dateExpected,
    orderID: mockOrderData?.orderID,
    shippingMethodID: mockOrderData?.shippingMethodID,
  } as GetOrderResponseType;
};
